import React, { useState, useEffect, useCallback } from 'react';
import { useTermsStore, useSubmitTermsAgreementPending, submitTermsAgreement } from '../hooks/useStores';
import { setMainButtonState, setMainButtonText, setMainButtonAction } from '../stores';
import './TermsAgreement.css';
import { TELEGRAM_CONFIG } from '../config/telegramConfig';

const TermsAgreement: React.FC = () => {
  const terms = useTermsStore();
  const isSubmitting = useSubmitTermsAgreementPending();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked);
  };

  const handleSubmit = useCallback(() => {
    console.log('handleSubmit called:', { isChecked, isSubmitting, isAgreed: terms.isAgreed });

    // Дополнительная защита: не отправляем согласие, если уже согласились или идет отправка
    if (isChecked && !isSubmitting && !terms.isAgreed) {
      console.log('Sending terms agreement...');
      submitTermsAgreement(true);
    } else {
      console.log('Terms agreement not sent:', { isChecked, isSubmitting, isAgreed: terms.isAgreed });
    }
  }, [isChecked, isSubmitting, terms.isAgreed]);

  // Управление текстом и состоянием MainButton
  useEffect(() => {
    // Всегда показываем кнопку "Принять и продолжить"
    setMainButtonText('Принять и продолжить');

    if (isChecked && !isSubmitting) {
      // Кнопка активна
      setMainButtonState('terms');
    } else {
      // Кнопка неактивна
      setMainButtonState('terms_inactive');
    }

    // Очистка при размонтировании компонента
    return () => {
      console.log('TermsAgreement component unmounted');
      /*
      if (isChecked && isSubmitting) {
        setMainButtonState('scan_inactive');
      }
      else {
        setMainButtonState('hidden');
      }*/
    };
  }, [isChecked, isSubmitting]);

  // Управление действием MainButton
  useEffect(() => {
    if (isChecked && !isSubmitting) {
      // Кнопка активна - можно нажимать
      setMainButtonAction(handleSubmit);
    } else {
      // Кнопка неактивна - показываем сообщение при нажатии
      setMainButtonAction(() => {
        if (!isChecked) {
          window.Telegram?.WebApp?.showAlert('Пожалуйста, согласитесь с условиями акции');
        } else if (isSubmitting) {
          window.Telegram?.WebApp?.showAlert('Пожалуйста, подождите завершения отправки');
        }
      });
    }
  }, [isChecked, isSubmitting, handleSubmit]);

  // Эффект для отслеживания успешного согласия
  useEffect(() => {
    if (terms.isAgreed && !terms.isVisible) {
      console.log('Terms agreement completed, MainButton should be activated by store logic');
    }
  }, [terms.isAgreed, terms.isVisible]);

  const handlePdfClick = () => {
    // Открываем HTML документ с условиями в новой вкладке
    window.open('/documents/terms.html', '_blank');
  };

  if (!terms.isVisible) {
    return null;
  }

  return (
    <>
      {/* Картинка с условиями */}
      <div className="promo-section">
        <img
          src="/images/terms2.jpg"
          alt=""
          className="terms-image"
        />
      </div>
      <div className="terms-section">
        {/* Ссылка на PDF документ */}
        <button
          type="button"
          className="pdf-link-button"
          onClick={handlePdfClick}
        >
          Ознакомиться с полными условиями акции
        </button>
        <div className="contact-hint">
          {/* Галочка согласия */}
          <div className="terms-checkbox-container">
            <label className="terms-checkbox-label">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                className="terms-checkbox"
                style={{ accentColor: TELEGRAM_CONFIG.mainButtonColor }}
              />
              <span className="terms-checkbox-text">
                Я согласен с условиями акции
              </span>
            </label>
          </div>
        </div>
      </div>

    </>
  );
};

export default TermsAgreement;
